import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { Store } from '@ngrx/store';
import { startWith, Subject, Subscription } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-supplier-product',
  templateUrl: './edit-supplier-product.component.html',
  styleUrls: ['./edit-supplier-product.component.css']
})
export class EditSupplierProductComponent implements OnInit {

  @Input() productData: any;
  @Input() selectedSupplierId: number;
  @Input() productModalMode: string;
  @Input() editOrUpdate!: string;
  @Output() refreshParentData = new EventEmitter<void>();
  @Input() productId!: number;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();
  @Output() productUpdated = new EventEmitter<any>();

  constructor(private store: Store<{ languageData: [] }>,
    private http: HttpClient, private domSanitizer: DomSanitizer, private sanitizer: DomSanitizer) { }

  // 🔽 Language support
  public lang: any = {};
  languageData$: any;
  selectedLanguage: string = '';
  // 🌐 Handle Language Tokens
  public getLanguageTokens(): void {
    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
    );

    this.languageData$.subscribe((data) => {
      if (
        !data ||
        !data.languageData ||
        Object.keys(data.languageData).length <= 0
      ) {
        console.log('No data to process', new Date().toISOString());
        return;
      }

      setTimeout(() => {
        this.lang = {};
        this.selectedLanguage = sessionStorage.getItem('language') ?? 'en';

        for (let token of data.languageData) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
      }, 0);
    });
  }

  // Added new Product
  showCreatedProduct: boolean = false;


  //close popup
  handleCancelation(): void {
    this.refreshParentData.emit();
    this.onClose.emit();
  }

  // input number field
  allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault(); // Block anything that's not a digit
    }
  }

  // Limits Section

  ageError: string = '';

  validateAgeRange() {
    if (this.product.limits.minAge != null && this.product.limits.maxAge != null) {
      const min = Number(this.product.limits.minAge);
      const max = Number(this.product.limits.maxAge);

      // Must be numbers
      if (isNaN(min) || isNaN(max)) {
        this.ageError = 'Ages must be numbers';
        return false;
      }

      // Min age check
      if (min < 18) {
        this.ageError = 'Minimum Age must be at least 18';
        return false;
      }

      // Max age check
      if (max > 70) {
        this.ageError = 'Maximum Age cannot be greater than 70';
        return false;
      }

      // Logical relation
      if (max <= min) {
        this.ageError = 'Max Age must be greater than Min Age';
        return false;
      }

      this.ageError = '';
      return true;
    }

    this.ageError = '';
    return true;
  }


  // ********************************** Handling Update Product **************************************
  product: any;
  // *************************** My First Row *************************************
  get isProductValidForFirstRow(): boolean {
    const data = (
      this.product.productInfo.productId.trim() !== '' &&
        this.product.productInfo.productName?.length > 0 &&
        this.product.productInfo.effectiveDistributionDate !== null &&
        this.product.productInfo.productIdentifier ? true : false &&
          this.product.productInfo.productCountry[0].name.trim() !== '' &&
          this.product.productInfo.selectedProvinces?.length > 0 &&
          this.product.productInfo.renewalDate ? true : false
    )
    return data;
  }

  countries = [
    { id: 2, name: 'Canada' },
    { id: 1, name: 'USA' }];

  countryDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };

  productIdentifier = [
    { id: 1, name: 'Mental Health & Wellbeing' },
    { id: 2, name: 'Health & Dental' },
    { id: 3, name: 'Life & Disability Protection' },
    { id: 4, name: 'Private Health' },
    { id: 5, name: 'Other' }
  ];
  showOtherInput: boolean = false;
  onSelectProductIdentityFier(item: any): void {
    console.log("onSelectProductIdentityFier :", item);
    this.showOtherInput = item.name === 'Other';
    if (!this.showOtherInput) {
      this.product.productInfo.productNewInputIdentifier = '';
    }
  }

  onDeselectProductIdentityFier(item: any): void {
    if (item.name === 'Other') {
      this.showOtherInput = false;
      this.product.productInfo.productNewInputIdentifier = '';
    }
  }

  onSelectBaseUnit(item: any): void {
    console.log("onSelectProductIdentityFier :", item);
    this.product.pricing.showOtherInputForBaseUnit = item.value === 'Other';
  }

  onDeselectonBaseUnit(item: any): void {
    if (item.value === 'Other') {
      this.product.pricing.showOtherInputForBaseUnit = false;
      this.product.pricing.otherInputForBaseUnit = '';
    }
  }
  formatCurrency(event: any) {
    let value: string = event.target.value;

    // Always keep $ at the start
    if (!value.startsWith('$')) {
      value = '$' + value.replace(/\$/g, '');
    }

    // Remove everything except numbers and .
    value = '$' + value.slice(1).replace(/[^0-9.]/g, '');

    // Allow only one "."
    const parts = value.slice(1).split('.');
    if (parts.length > 2) {
      value = '$' + parts[0] + '.' + parts.slice(1).join('');
    }

    event.target.value = value;
    this.product.pricing.otherInputForBaseUnit = value;
  }

  ensureDollar(event: any) {
    let value: string = event.target.value;
    if (value.trim() === '' || value === '$') {
      event.target.value = '$';
      this.product.pricing.otherInputForBaseUnit = '$';
    }
  }


  provinces = [
    { id: 1, name: 'Alberta', shortName: 'AB' },
    { id: 2, name: 'British Columbia', shortName: 'BC' },
    { id: 3, name: 'Manitoba', shortName: 'MB' },
    { id: 4, name: 'New Brunswick', shortName: 'NB' },
    { id: 5, name: 'Newfoundland and Labrador', shortName: 'NL' },
    { id: 6, name: 'Nova Scotia', shortName: 'NS' },
    { id: 7, name: 'Ontario', shortName: 'ON' },
    { id: 8, name: 'Prince Edward Island', shortName: 'PE' },
    { id: 9, name: 'Quebec', shortName: 'QC' },
    { id: 10, name: 'Saskatchewan', shortName: 'SK' },
    { id: 11, name: 'Northwest Territories', shortName: 'NT' },
    { id: 12, name: 'Nunavut', shortName: 'NU' },
    { id: 13, name: 'Yukon', shortName: 'YT' }
  ];

  // ****************************** Third Row ****************************************
  pdfBase64Data: string | null = null;
  tileSafeUrl: SafeResourceUrl | null = null;
  showTileExcelPopup: boolean = false
  html = '';
  // product resource
  showProduct_Resource_QuillEditor: boolean = false;
  savedProductResourceContent = '';
  previewProduct_Resource_QuillEditor: boolean = false;
  editorContentForProductResource: string = '';
  safeHtml: SafeHtml;

  // Tile description
  showTileQuillEditor: boolean = false;
  previewQuillEditor: boolean = false;
  savedContent: String = "";
  tilePreviewType: 'text' | 'excel' | 'pdf' | 'doc' | 'unsupported' | null = null;

  // something
  showEditor = false;

  //Handing booklet pdf
  bookletUrl: SafeResourceUrl | null = null;
  bookletFileName: string = "";
  tileTextContent: string | null = null;

  // ************************************ Toolkit handle ****************************************
  bookletFiles: { name: string, base64Data: string }[] = [];
  selectedFiles: { file: File, url: SafeResourceUrl, name: string }[] = [];
  showPopup = false;
  showPopupPdf = false;
  showToolkitPDF = false;
  showPdfViewerPopup = false;
  currentPdfUrl: SafeResourceUrl | null = null;

  handleTookletFile(event: any) {
    const files: FileList = event.target.files;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.type === 'application/pdf') {
        if (this.product.productDetails.bookletFile.length < 5) {
          const fileUrl = URL.createObjectURL(file);
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);


          const reader = new FileReader();
          reader.onload = () => {
            const base64Data = (reader.result as string).split(',')[1];
            this.product.productDetails.bookletFile.push({
              name: file.name,
              base64Data: base64Data
            });
          };
          reader.readAsDataURL(file);
        }
      }
    }
    event.target.value = '';
  }
  currentPDFName: string = "";
  viewPdf(pdfUrl: SafeResourceUrl, name: string) {
    this.currentPdfUrl = pdfUrl;
    this.currentPDFName = name;
    this.showToolkitPDF = true

    try {
      const url = `data:application/pdf;base64,${pdfUrl}`;
      this.currentPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.showToolkitPDF = true
      this.currentPDFName = name;

    } catch (error) {
      console.log("booklet error :", error)
    }
  }


  closePopup() {
    this.showPopup = false;
    this.currentPdfUrl = null;
  }

  deletePdf(index: number) {
    this.product.productDetails.bookletFile.splice(index, 1);
    if (this.product.productDetails.bookletFile.length === 0) {
      this.showPopup = false
    }
  }

  // ************************************* End Toolkit ****************************************


  // product resource
  onViewProduct_Resource_Description() {
    this.product.productDetails.productResourceHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.productResourceContent);
    this.previewProduct_Resource_QuillEditor = true;
  }
  onCanceloOfProductResourceDescription(): void {
    this.showProduct_Resource_QuillEditor = false
    // this.product.productDetails.productResourceContent = null;
  }
  quillModulesForProductResource = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };

  tempForProductResource: String = "";
  tempForTileDescription: String = "";

  handleProductResource(): void {
    this.tempForProductResource = this.product.productDetails.productResourceContent
    this.showProduct_Resource_QuillEditor = true;
  }
  handleTileDecription(): void {
    this.tempForTileDescription = this.product.productDetails.tileDescriptionContent
    this.showTileQuillEditor = true;
  }
  onProductResourceFileSave(): void {
    // Step 1: Store the editor content for preview
    this.product.productDetails.productResourceContent = this.tempForTileDescription;
    this.savedProductResourceContent = this.product.productDetails.productResourceContent;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
    this.product.productDetails.productResourceHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.productResourceContent);

    this.showProduct_Resource_QuillEditor = false;
    // this.product.productDetails.tileDescriptionContent = null;
  }
  onProductPreviewClosePopup() {
    this.previewProduct_Resource_QuillEditor = false;
  }

  //Tile decription
  onViewTileDescription() {
    this.product.productDetails.tileDescriptionHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.tileDescriptionContent);
    this.previewQuillEditor = true;
  }
  onCanceloOfTileDescription(): void {
    this.showTileQuillEditor = false
    // this.product.productDetails.tileDescriptionContent = null;
  }
  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };

  onTileFileSave(): void {
    this.product.productDetails.tileDescriptionContent = this.tempForTileDescription;
    // Step 1: Store the editor content for preview
    this.savedContent = this.product.productDetails.tileDescriptionContent;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
    this.product.productDetails.tileDescriptionHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.tileDescriptionContent);
    this.showTileQuillEditor = false;
    // this.product.productDetails.tileDescriptionContent = null;
  }

  previewTileLogoUrl: string | ArrayBuffer | null = null;
  handleTileLogo(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    console.log("got tile file:", file);

    const reader = new FileReader();
    reader.onload = () => {
      this.product.productDetails.tileLogo = reader.result as string;
    };
    reader.readAsDataURL(file);
  }
  onClosePopup() {
    this.previewQuillEditor = false;
  }
  // close popup
  resetTilePreview(): void {
    this.showTileExcelPopup = false;
  }

  // ******************************* Vendor And Invoicing Section ********************************
  onBillingTypeChange() {
    this.product.productDetails.paymentOption = "PAD From GB";
  }

  // ******************************** Pricing *********************************************
  baseUnitValues = [
    { id: 1, value: '$1' },
    { id: 2, value: '$100' },
    { id: 3, value: '$1000' },
    { id: 4, value: '$10000' },
    { id: 5, value: '$100000' },
    { id: 6, value: '$1000000' },
    { id: 7, value: 'Other' }
  ];

  // ************************************* Five Table **************************************

  filteredProvinces: any[] = [];

  // product: any = {};
  showProductModal: boolean = false;

  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true
  };

  //my first row functions code
  onItemSelect(item: any) {
    this.updateFilteredProvinces();
    console.log('Selected:', item);
  }

  onSelectAll(items: any) {
    console.log('All Selected:', items);
    this.updateFilteredProvinces();
    this.filteredProvinces = [...items];
  }


  onDeSelectAll(items: any) {
    this.filteredProvinces = [];
  }

  onItemDeSelect(item: any) {
    this.updateFilteredProvinces();
  }

  //here we are filtering provinces to show in pricing area section dropdown
  updateFilteredProvinces() {
    this.filteredProvinces = this.product.areas.areasData.selectedProvinces;
  }

  //increase table rows 
  generatePricingAreaRows(count: number) {
    this.product.areas.areasData = [];
    for (let i = 0; i < count; i++) {
      this.product.areas.areasData.push({
        area: i + 1,
        name: '',
        selectedProvinces: []
      });
    }
  }

  // increase tier table row
  generateTieredRows(count: number) {
    this.product.tiers.tiersData = Array.from({ length: count }, () => ({ name: '' }));
    if (this.product.tiers.noOfTiers <= 0) {
      this.product.tiers.isTierEnabled = false;
      this.product.tiers.noOfTiers = null;
    } else {
      this.product.tiers.isTierEnabled = true;
    }
  }
  // Filtered list per row
  getAvailableProvinces(index: number) {
    const selectedInOthers = this.product.areas.areasData
      .filter((_, i) => i !== index)
      .flatMap(r => r.selectedProvinces.map(p => p.id));

    return this.filteredProvinces.filter(
      p => !selectedInOthers.includes(p.id)
    );
  }
  //pricing provinces setting
  pricingProvincesdropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false
  };
  // ************************************ End All Fields ***********************************

  generateVariants(count: number) {
    this.product.variants.variantsData = [];
    for (let i = 0; i < count; i++) {
      this.product.variants.variantsData.push({
        name: '',
      });
    }
  }
  generateAgeBands(count: number) {
    this.product.ageBands.ageBandsData = [];
    for (let i = 0; i < count; i++) {
      this.product.ageBands.ageBandsData.push({
        start: null,
        end: null,
      });
    }
    this.product.ageBands.noOfAgeBands = count;
  }
  generateCategoryRows(count: number) {
    this.product.serviceLevel.servicesData = [];
    for (let i = 0; i < count; i++) {
      this.product.serviceLevel.servicesData.push({
        name: '',
      });
    }
    // this.product.serviceLevel.servicesData = Array.from({ length: count }, () => ({ name: '' }));
    // if (this.product.serviceLevel.noOfServiceLevel <= 0) {
    //   this.product.serviceLevel.isServiceLevelEnabled = false;
    //   this.product.serviceLevel.noOfServiceLevel = null;
    // } else {
    //   this.product.serviceLevel.isServiceLevelEnabled = true;
    // }
  }
  // This updates next row's start when current row's end changes
  onEndChange(index: number): void {
    const currentEnd = this.product.ageBands.ageBandsData[index].end;
    if (index + 1 < this.product.ageBands.ageBandsData.length) {
      this.product.ageBands.ageBandsData[index + 1].start = currentEnd;
    }
  }
  onAgeBandChange(value: boolean): void {
    this.product.ageBands.isAgeBandEnabled = value;
    if (value) {
      this.product.tiers.isTierEnabled = false;
      this.product.tiers.noOfTiers = null
      this.product.tiers.tiersData = [];
    } else {
      this.product.ageBands.ageBandsData = [];
      this.product.ageBands.noOfAgeBands = null;
    }
  }
  onTierChange(value: boolean): void {
    this.product.tiers.isTierEnabled = value;

    if (value) {
      this.product.ageBands.isAgeBandEnabled = false;
      this.product.ageBands.noOfAgeBands = null;
      this.product.ageBands.ageBandsData = [];
    } else {
      this.product.tiers.tiersData = [];
      this.product.tiers.noOfTiers = null;
    }
  }
  onVarientChange(value: boolean): void {
    this.product.variants.isVariantEnabled = value;
    this.product.variants.noOfVariants = null;
    this.product.variants.variantsData = [];
  }
  onServiceLevelChange(value: boolean): void {
    this.product.serviceLevel.isServiceLevelEnabled = value;
    this.product.serviceLevel.noOfServiceLevel = null;
    this.product.serviceLevel.servicesData = [];
  }

  // Validation for tables
  errorsForTable: any = [];
  validateTables(): boolean {
    this.errorsForTable = []; // reset errors

    // 1. Zone validation
    if (this.product.areas.noOfAreas > 0) {
      this.product.areas.areasData.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Zone row ${idx + 1}: Name is required`);
        }
        if (!row.selectedProvinces || row.selectedProvinces.length === 0) {
          this.errorsForTable.push(`Zone row ${idx + 1}: At least one province is required`);
        }
      });
    }

    // 2. Tier validation
    if (this.product.tiers.noOfTiers > 0) {
      this.product.tiers.tiersData.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Tier row ${idx + 1}: Name is required`);
        }
      });
    }

    // 3. Variant validation
    if (this.product.variants.noOfVariants > 0) {
      this.product.variants.variantsData.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Variant row ${idx + 1}: Name is required`);
        }
      });
    }

    // 4. Category validation
    if (this.product.serviceLevel.noOfServiceLevel > 0) {
      this.product.serviceLevel.servicesData.forEach((row, idx) => {
        if (!row.name?.trim()) {
          this.errorsForTable.push(`Category row ${idx + 1}: Name is required`);
        }
      });
    }

    // 5. Age band validation

    if (this.product.ageBands.ageBandsData.length > 0) {
      this.product.ageBands.ageBandsData.forEach((row, idx) => {
        if (row.start == null) {
          this.errorsForTable.push(`Age Band row ${idx + 1}: Start is required`);
        }
        if (row.end == null) {
          this.errorsForTable.push(`Age Band row ${idx + 1}: End is required`);
        }
      });
    }

    return this.errorsForTable.length === 0; // ✅ true if valid, false if errors exist
  }
  // ************************************** Signup Form ***************************************
  showPopups = false;

  fieldTypes = [
    { id: 1, name: 'Text' },
    { id: 2, name: 'Email field' },
    { id: 3, name: 'Phone field' },
    { id: 4, name: 'Number' },
    { id: 5, name: 'Date picker' },
    { id: 6, name: 'Dropdown' },
    { id: 7, name: 'Radio button' },
    { id: 8, name: 'Checkbox' },
    { id: 9, name: 'File upload' },
    { id: 10, name: 'Signature pad' }
  ];
  fieldName = '';
  fieldRules = '';

  signUpFieldType: string = "";
  tempForSignupSheet: any[] = [];
  // Dropdown options
  signupTemplates = [
    { id: 1, text: 'Health & Dental' },
    { id: 2, text: 'Wellness' },
    { id: 3, text: 'Life, CI & AD&D' },
    { id: 4, text: 'LTD & Life' },
    { id: 5, text: 'Life' },
    { id: 6, text: 'New template' }
  ];
  // Settings for ng-multiselect-dropdown
  templateDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'text',
    allowSearchFilter: false,
    closeDropDownOnSelection: true,
    enableCheckAll: false,
    clearable: true
  };

  openPopup() {
    if (this.tempForSignupSheet.length === 0) {
      this.tempForSignupSheet = this.product.signUpData
    }
    this.showPopups = true;
  }
  getActiveCount(): number {
    if (!this.product.signUpData.template.fields.length) {
      return 23
    }
    return this.product.signUpData.template.fields.filter(f => f.active).length;
  }
  addField() {
    if (!this.fieldName || !this.signUpFieldType) return;

    this.tempForSignupSheet.push({
      name: this.fieldName,
      type: this.signUpFieldType,
      rules: this.fieldRules,
      active: true
    });

    this.fieldName = '';
    this.signUpFieldType = '';
    this.fieldRules = '';
  }

  deleteField(index: number) {
    this.tempForSignupSheet.splice(index, 1);
  }

  onCancel() {
    this.getActiveCount();
    this.showPopups = false;
    // Close modal logic
  }
  getSignupSheetData(): Array<{
    name: string;
    type: { id: number; name: string }[];
    rules: string;
    active: boolean;
  }> {
    return [
      { name: 'Plan Enrollment Date', type: [{ id: 5, name: 'Date picker' }], rules: 'required', active: true },
      { name: 'First Name', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Last Name', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Email', type: [{ id: 2, name: 'Email field' }], rules: 'required|email', active: true },
      { name: 'Phone Number', type: [{ id: 3, name: 'Phone field' }], rules: 'required|phone', active: true },
      { name: 'Street Address', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Street Address Line 2', type: [{ id: 1, name: 'Text' }], rules: '', active: true },
      { name: 'Unit/Apt/Suite', type: [{ id: 1, name: 'Text' }], rules: '', active: true },
      { name: 'City', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Province of Residence', type: [{ id: 6, name: 'Dropdown' }], rules: 'required', active: true },
      { name: 'Postal Code', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Province of Employment', type: [{ id: 6, name: 'Dropdown' }], rules: 'required', active: true },
      { name: 'Date of Birth', type: [{ id: 5, name: 'Date picker' }], rules: 'required|date', active: true },
      { name: 'Gender', type: [{ id: 6, name: 'Dropdown' }], rules: 'required', active: true },
      { name: 'Date of Hire', type: [{ id: 5, name: 'Date picker' }], rules: 'required|date', active: true },
      { name: 'Company Name', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Job Title', type: [{ id: 1, name: 'Text' }], rules: 'required', active: true },
      { name: 'Work Eligibility Confirmation', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Provincial Health Coverage Confirmation', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Spouse Information', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Dependent Children Information', type: [{ id: 7, name: 'Radio button' }], rules: 'required', active: true },
      { name: 'Agree to Terms & Conditions', type: [{ id: 8, name: 'Checkbox' }], rules: 'required', active: true },
      { name: 'Advisor Disclosure Agreement', type: [{ id: 8, name: 'Checkbox' }], rules: 'required', active: true }
    ];
  }



  onReset(): void {
    this.tempForSignupSheet = this.getSignupSheetData()
  }
  replaceSaveName: String = "Save"
  numberOfFields: Number = 0;

  onSaveSignupSheet() {
    this.replaceSaveName = "Saved"
    this.product.signUpData.template.fields = this.tempForSignupSheet
    this.numberOfFields = this.getActiveCount();
    // this.tempForSignupSheet = this.product.signUpData.template.fields 
    console.log('Signup Final Fields:', this.tempForSignupSheet);
    setTimeout(() => {
      this.showPopups = false;
      this.replaceSaveName = "Save"
    }, 300);
  }


  onTemplateSelect(event: any) {
    this.tempForSignupSheet = event.text !== 'New template' ? this.getSignupSheetData() : []
    this.showPopups = true;
  }

  editTemplate(){
     this.tempForSignupSheet =  this.product.signUpData.template.fields
    this.showPopups = true;
  }



  getSignupPayload() {
    return {
      targets: {
        individual: this.product.signUpData.targets.individual,
        corporate: this.product.signUpData.targets.corporate,
        isGroupPlan: this.product.signUpData.targets.isGroupPlan,
        minHeadcount: this.product.signUpData.targets.isGroupPlan ? this.product.signUpData.targets.minHeadcount : null
      },
      template: {
        selected: this.product.signUpData.template.selected,
        fields: this.product.signUpData.template.fields   // these are saved in onSave()
      }
    }
  }

  reportingFileTypes = [
    { id: 1, name: 'Excel' },
    { id: 2, name: 'PDF' },
    { id: 3, name: 'CSV' }];

  customerFields = [
    { id: 1, name: 'Customer ID' },
    { id: 2, name: 'First Name' },
    { id: 3, name: 'Last Name' },
    { id: 4, name: 'Phone Number' },
    { id: 5, name: 'Province' },
    { id: 6, name: 'Status' },
    { id: 7, name: 'Plan Start Date' },
    { id: 8, name: 'Plan Termination Date' }
  ];

  reportingFileTypeDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  reportingPeriodDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };
  selfBillingDropdownSettings = {
    singleSelection: false,
    idField: 'fieldName',
    textField: 'fieldName',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  censusDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  onProvisioningSelfBilling() {
    // const fieldNames = this.rows.flatMap(obj =>
    //   obj.fields.map(field => field.fieldName)
    // );

    // // Convert string array to array of objects with fieldName property
    // this.product.provisioningAndReporting.fieldsForSelfBilling = fieldNames.map(name => ({ fieldName: name }));

    // console.log("signup form data:", this.product.provisioningAndReporting.fieldsForSelfBilling);

    this.product.provisioningAndReporting.isSelfBillingEnabled = true;
  }

  // ********************************* Provisioning And Reporting ***********************************************************

  monthList = [
    { name: "January" },
    { name: "February" },
    { name: "March" },
    { name: "April" },
    { name: "May" },
    { name: "June" },
    { name: "July" },
    { name: "August" },
    { name: "September" },
    { name: "October" },
    { name: "November" },
    { name: "December" }
  ];
  months = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' }
  ];


  // product.provisioningAndReporting.reporting.selfBilling.fields

  // product.provisioningAndReporting.reporting.combineReports: any[] = [];
  // product.provisioningAndReporting.reporting.census.fields: any[] = [];

  // product.provisioningAndReporting.reporting.compileMode
  // combineReports = false;
  // maintainHistory = false;
  // compileMode = [{ id: 'compile', name: 'Compile' }];

  // deliveryMethod = [{ id: 'email', name: 'Email' }];
  // emailRecipients = '';
  // sftpHost = '';
  // sftpPath = '';

  // product.provisioningAndReporting.provisioning.interfaces.web.fields

  // dynamic field management

  addFields(type: string) {
    if (type === 'web') this.product.provisioningAndReporting.provisioning.interfaces.web.fields.push({ key: '', value: '' });
    if (type === 'api') this.product.provisioningAndReporting.provisioning.interfaces.api.fields.push({ key: '', value: '' });
    if (type === 'self') this.product.provisioningAndReporting.reporting.selfBilling.fields.push({ key: '', value: '' });
    if (type === 'census') this.product.provisioningAndReporting.reporting.census.fields.push({ key: '', value: '' });
  }

  removeField(type: string, i: number) {
    if (type === 'web') this.product.provisioningAndReporting.provisioning.interfaces.web.fields.splice(i, 1);
    if (type === 'api') this.product.provisioningAndReporting.provisioning.interfaces.api.fields.splice(i, 1);
    if (type === 'self') this.product.provisioningAndReporting.reporting.selfBilling.fields.splice(i, 1);
    if (type === 'census') this.product.provisioningAndReporting.reporting.census.fields.splice(i, 1);
  }





  // ************************************ Conditional Tables ******************************************
  selectedZone = false;
  selectedTier = false;
  selectedAge = false;
  selectedVariant = false;
  selectedCategory = false;


  // Pricing matrix for all possible combinations
  pricingMatrix: {
    [zone: string]: any;
  } = {};

  // For simpler tables (zone -> item only, for example)
  flatPricingMatrix: any = {};

  showTable(): void {
    if (!this.validateTables()) {
      console.log("❌ Validation failed", this.errorsForTable);
      return;
    }
    this.updateSelectedFlags();
    this.initializePricingMatrix();
    this.product.pricing.showPricingTable = true;
  }

  updateSelectedFlags(): void {
    this.selectedZone = this.product.areas.areasData.length > 0;
    this.selectedTier = this.product.tiers.tiersData.length > 0;
    this.selectedAge = this.product.ageBands.ageBandsData.length > 0;
    this.selectedVariant = this.product.variants.variantsData.length > 0;
    this.selectedCategory = this.product.serviceLevel.servicesData.length > 0;

    this.resolveTableFormat();
  }
  resolveTableFormat(): void {
    const z = this.selectedZone;
    const t = this.selectedTier;
    const a = this.selectedAge;
    const v = this.selectedVariant;
    const c = this.selectedCategory;

    if (z && t && a && v && c) this.product.pricing.showTableType = 'zone-tier-age-variant-category';
    else if (z && t && a && v) this.product.pricing.showTableType = 'zone-tier-age-variant';
    else if (z && t && a && c) this.product.pricing.showTableType = 'zone-tier-age-category';
    else if (z && t && v && c) this.product.pricing.showTableType = 'zone-tier-variant-category';
    else if (z && a && v && c) this.product.pricing.showTableType = 'zone-age-variant-category';
    else if (t && a && v && c) this.product.pricing.showTableType = 'tier-age-variant-category';
    else if (z && t && a) this.product.pricing.showTableType = 'zone-tier-age';
    else if (z && a && v) this.product.pricing.showTableType = 'zone-age-variant';
    else if (z && a && c) this.product.pricing.showTableType = 'zone-age-category';
    else if (z && t && v) this.product.pricing.showTableType = 'zone-tier-variant';
    else if (z && t && c) this.product.pricing.showTableType = 'zone-tier-category';
    else if (t && a && c) this.product.pricing.showTableType = 'tier-age-category';
    else if (t && v && c) this.product.pricing.showTableType = 'tier-variant-category';
    else if (z && v && c) this.product.pricing.showTableType = 'zone-variant-category';
    else if (t && c) this.product.pricing.showTableType = 'tier-category';
    else if (t && v) this.product.pricing.showTableType = 'tier-variant';
    else if (v && c) this.product.pricing.showTableType = 'variant-category';
    else if (z && t) this.product.pricing.showTableType = 'zone-tier';
    else if (z && v) this.product.pricing.showTableType = 'zone-variant';
    else if (z && c) this.product.pricing.showTableType = 'zone-category';
    else if (t && a) this.product.pricing.showTableType = 'tier-age';
    else if (z && a) this.product.pricing.showTableType = 'zone-age';
    else if (a && c) this.product.pricing.showTableType = 'age-category';
    else if (z) this.product.pricing.showTableType = 'zone-only';
    else this.product.pricing.showTableType = 'default';
  }

  initializePricingMatrix(): void {
    const zRows = this.product.areas.areasData.map(z => z.name || 'default');
    const tRows = this.product.tiers.tiersData.map(t => t.name || 'default');
    const aRows = this.product.ageBands.ageBandsData.map(a => `${a.start}-${a.end}` || 'default');
    const vRows = this.product.variants.variantsData.map(v => v.name || 'default');
    const cRows = this.product.serviceLevel.servicesData.map(c => c.name || 'default');

    for (const z of zRows.length ? zRows : ['default']) {
      for (const t of tRows.length ? tRows : ['default']) {
        for (const a of aRows.length ? aRows : ['default']) {
          for (const v of vRows.length ? vRows : ['default']) {
            for (const c of cRows.length ? cRows : ['default']) {
              this.initializePricingPath(z, t, a, v, c);
            }
          }
        }
      }
    }
  }

  initializePricingPath(...keys: string[]) {
    let ref = this.product.pricingMatrix;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i] && keys[i].trim() !== '' ? keys[i] : 'default';

      if (!ref[key]) {
        ref[key] = i === keys.length - 1
          ? {
            'Unit Price': 0,
            'Advisor Commission': 0,
            'TPA Commission': 0,
            'Other Fees': 0
          }
          : {};
      } else if (i === keys.length - 1 && typeof ref[key] === 'object') {
        // If object already exists, patch missing fields (in case of partial data)
        ref[key] = {
          'Unit Price': (() => {
            const value = this.product.pricing.unitPrice ?? ref[key]['Unit Price'] ?? 0;
            const type = this.product.pricing.unitPriceType;

            if (type === '%') {
              return `${value}%`;
            } else if (type === '$') {
              return `$${value}`;
            } else {
              return value;
            }
          })(),

          'Advisor Commission': (() => {
            const value = this.product.pricing.advisorCommission ?? ref[key]['Advisor Commission'] ?? 0;
            const type = this.product.pricing.advisorCommissionType;

            if (type === '%') {
              return `${value}%`;
            } else if (type === '$') {
              return `$${value}`;
            } else {
              return value;
            }
          })(),

          'TPA Commission': (() => {
            const value = this.product.pricing.tpaCommission ?? ref[key]['TPA Commission'] ?? 0;
            const type = this.product.pricing.tpaCommissionType;

            if (type === '%') {
              return `${value}%`;
            } else if (type === '$') {
              return `$${value}`;
            } else {
              return value;
            }
          })(),

          'Other Fees': (() => {
            const value = this.product.pricing.otherFees ?? ref[key]['Other Fees'] ?? 0;
            const type = this.product.pricing.otherFeesType;

            if (type === '%') {
              return `${value}%`;
            } else if (type === '$') {
              return `$${value}`;
            } else {
              return value;
            }
          })(),

        };
      }

      ref = ref[key];
    }
  }

  getPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails
  ): number {
    try {
      return (
        this.product.pricingMatrix?.[zone || 'default']
        ?.[(tier || 'default')]
        ?.[(age || 'default')]
        ?.[(variant || 'default')]
        ?.[(category || 'default')]
        ?.[field] ?? 0
      );
    } catch {
      return 0;
    }
  }


  setPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails,
    value: number
  ): void {
    const keys = [zone, tier, age, variant, category].map(k => k || 'default');

    let ref = this.product.pricingMatrix;
    for (const key of keys) {
      if (!ref[key]) ref[key] = {};
      ref = ref[key];
    }

    ref[field] = value;
  }


  allowCurrencyOrPercent(event: KeyboardEvent, value: string) {
    const key = event.key;
    const cursor = (event.target as HTMLInputElement).selectionStart ?? 0;

    // allow control/navigation keys
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];
    if (allowedKeys.includes(key)) {
      // block deleting $/% symbols
      if ((key === 'Backspace' && (value[cursor - 1] === '$' || value[cursor - 1] === '%')) ||
        (key === 'Delete' && (value[cursor] === '$' || value[cursor] === '%'))) {
        event.preventDefault();
      }
      return;
    }

    // allow only digits
    if (!/^\d$/.test(key)) {
      event.preventDefault();
      return;
    }

    // enforce placement rules
    if (value.startsWith('$') && cursor === 0) {
      // can't type before $
      event.preventDefault();
    }
    if (value.endsWith('%') && cursor > value.length - 1) {
      // can't type after %
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text') || '';
    const digits = pasteData.replace(/\D/g, ''); // keep only digits
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // enforce placement
    let cursor = input.selectionStart ?? 0;
    if (value.startsWith('$') && cursor === 0) cursor = 1;
    if (value.endsWith('%') && cursor >= value.length) cursor = value.length - 1;

    const newValue = value.slice(0, cursor) + digits + value.slice(cursor);
    input.value = newValue;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  openBookletPreview(): void {
    try {
      const base64 = this.product.productDetails.bookletFile;
      const url = `data:application/pdf;base64,${base64}`;
      this.bookletUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.showTileExcelPopup = true
    } catch (error) {
      console.log("booklet error :", error)
    }
  }

  
 closeComponent():void{
     this.refreshParentData.emit(); 
     this.onClose.emit();
    //  window.location.reload();
  }
  // Update Product
  onUpdateProduct(): void {
    if (this.editOrUpdate === 'Update Section') {
      const supplierId = this.selectedSupplierId
      const productId = this.product.productInfo.productId
      const url = `${environment.apiUrl}/api/ap/suppliers/update-product/${supplierId}/${productId}`;
      this.http.patch(url,
        { productData: this.product }
      ).subscribe({
        next: (res: any) => {
          console.log('Product updated successfully:', res);
          this.handleCancelation();
          // this.showProductUpdatePopup = true; // Set to true to show confirmation popup
        },
        error: (err) => {
          console.error('Error updating product:', err);
          // this.showProductUpdatePopup = false;
        }
      });
      console.log("updated product :", this.product)
    }
    if (this.editOrUpdate === 'Edit Section') {
      console.log("dontknow:", this.product)
      this.productUpdated.emit(this.product);
    }
    if (this.editOrUpdate === 'Add Section') {
      alert("add new ")
      const supplierId = this.selectedSupplierId;
      const url = `${environment.apiUrl}/api/ap/suppliers`;
      this.http.post(`${url}/add-product/${supplierId}`, { productData: this.product }).subscribe({
        next: (res: any) => {
          console.log('Product added successfully:', res);
          this.showCreatedProduct = true;
        },
        error: (err) => {
          console.error('Error adding product:', err);
        }
      });
    }

  }
        // generate ProductID
  generateProductID(): string {
    const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const randomNumber = Math.floor(10000 + Math.random() * 90000);
    return `${randomLetter}-${randomNumber}`;
  }

  ngOnInit(): void {
    this.getLanguageTokens();
    this.product = cloneDeep(this.productData);
    if(this.editOrUpdate==='Add Section'){
      this.product.productInfo.productId =  this.generateProductID();
    }
    console.log("productDataproductDataproductDataproductDataproductDataproductDataproductDataproductDataproductDataproductDataproductDataproductData :", this.productData)

    this.filteredProvinces = this.product.productInfo.selectedProvinces;

    // Convert string array to array of objects with fieldName property
    this.product.provisioningAndReporting.fieldsForSelfBilling = [];
    console.log("Product :", this.product);

    // showing pricing tables
    // this.showTable()

  }

  //close popup
  handleCancel(): void {
    this.onClose.emit();
  }

  // Akash + George Question  Cards and Certificates

  // Q2: No. of product.productDetails.getHealthCardsPayload.cards

  fileTypes = ["CSV", "Excel", "PDF"];
  frequencies = ["Monthly", "Quarterly", "Half-yearly", "Yearly"];


  // Dropdown options
  cardTypeOptions = [
    { id: 'health', text: 'Health Card' },
    { id: 'certificate', text: 'Certificate' }
  ];

  cardSourceOptions = [
    { id: 'portal', text: 'Through Supplier Portal' },
    { id: 'supplier', text: 'Provided by Supplier' },
    { id: 'system', text: 'Generated by System' }
  ];

  // Single-select settings for ng-multiselect-dropdown (your reference component)
  singleSelectDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'text',
    closeDropDownOnSelection: true,
    allowSearchFilter: false,
    enableCheckAll: false,
    itemsShowLimit: 1
  };

  // Keep your integer-only guard for the number input
  validateInteger(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Home',
      'End'
    ];

    // Allow navigation/control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Allow only digits (0–9)
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  validatePaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData?.getData('text') ?? '';
    if (!/^[0-9]*$/.test(pasteData)) {
      event.preventDefault();
    }
  }



  // Adjust rows whenever product.productDetails.getHealthCardsPayload.product.productDetails.getHealthCardsPayload.product.productDetails.getHealthCardsPayload.numCards changes
  onNumCardsChange(value: number | null) {
    const n = Math.max(0, Number(value || 0));
    // Expand
    while (this.product.productDetails.getHealthCardsPayload.cards.length < n) {
      this.product.productDetails.getHealthCardsPayload.cards.push({ type: [], source: [] });
    }
    // Shrink
    if (this.product.productDetails.getHealthCardsPayload.cards.length > n) {
      this.product.productDetails.getHealthCardsPayload.cards.splice(n);
    }
  }

}

export interface PricingDetails {
  'Unit Price'?: number;
  'Advisor Commission'?: number;
  'TPA Commission'?: number;
  'Other Fees'?: number;
}